/* eslint-disable complexity */
import { DialogProps } from '@design-system/dialog';

import { ModalExternal } from './models';

export const modalExternalMapper = (
  modalExternal: ModalExternal
): DialogProps => {
  const {
    secondaryButtonLabel,
    primaryButtonLabel,
    headline,
    description,
    closeAriaLabel,
    primaryButtonAriaLabel,
    secondaryButtonAriaLabel,
    mode,
    showIcon,
    showCloseButton,
    showOverlay,
  } = modalExternal;

  return {
    primaryButtonLabel,
    secondaryButtonLabel,
    ...(headline && { titleContent: headline }),
    ...(description && { data: description }),
    ...(mode && { mode }),
    ...(showIcon && { showIcon }),
    ...(showCloseButton && { showCloseButton }),
    ...(showOverlay && { showOverlay }),
    ...(closeAriaLabel && { closeAriaLabel }),
    ...(primaryButtonAriaLabel && { primaryButtonAriaLabel }),
    ...(secondaryButtonAriaLabel && { secondaryButtonAriaLabel }),
  } as DialogProps;
};
